var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8985 12.1422L12.3828 10.6355C12.2327 10.5715 12.0658 10.558 11.9072 10.597C11.7487 10.6361 11.6072 10.7256 11.5039 10.8521L9.94702 12.7543C7.50358 11.6022 5.53717 9.63579 4.38511 7.19235L6.28732 5.63543C6.41403 5.53237 6.50372 5.39083 6.5428 5.23225C6.58188 5.07366 6.56822 4.90666 6.50391 4.75652L4.99721 1.2409C4.92662 1.07906 4.80177 0.946918 4.64419 0.867268C4.48661 0.787618 4.30617 0.765449 4.134 0.804584L0.869489 1.55793C0.703492 1.59626 0.555389 1.68973 0.449352 1.82307C0.343315 1.95642 0.285606 2.12177 0.285645 2.29213C0.285645 10.3435 6.81152 16.8569 14.8504 16.8569C15.0208 16.857 15.1862 16.7993 15.3196 16.6933C15.453 16.5872 15.5465 16.4391 15.5849 16.273L16.3382 13.0085C16.3771 12.8355 16.3545 12.6543 16.2742 12.4962C16.194 12.3381 16.0611 12.2129 15.8985 12.1422Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_476_4551",
    x1: 16.9025,
    y1: 2.92678,
    x2: -9.88218,
    y2: -17.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fd22edddbf615bde99737efa3e29b63a.svg";
export { ForwardRef as ReactComponent };